import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import ImageGrid from "./ImageGrid";

const API = process.env.REACT_APP_API_URL || "";

function CollectionSpecific() {
  const { folder } = useParams();

  useEffect(() => {
    document.title = `Collections - ${folder}`;
  }, [folder]);

  const [hasError, setHasError] = useState(false);
  const [collectionImages, setCollectionImages] = useState([]);
  const [imageCount, setImageCount] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  const folderUrl = `${API}/folder/${encodeURIComponent(folder)}`;

    useEffect(() => {
    const fetchCollectionImages = async () => {
        setIsLoading(true);
        setHasError(false);

        try {
        const folderUrl = `${API}/folder/${encodeURIComponent(folder)}`;

        const response = await fetch(folderUrl);

        if (!response.ok) {
            throw new Error(`Failed to fetch images for folder: ${folder}`);
        }

        const data = await response.json();

        const images = data.images || [];

        setCollectionImages(images);
        setImageCount(data.totalCount || images.length);

        } catch (error) {
        console.error("Error fetching collection images:", error);
        setHasError(true);
        }

        setIsLoading(false);
    };

    fetchCollectionImages();

    }, [folder]);

  if (isLoading) {
    return <div className="body-container">Loading...</div>;
  }

  if (hasError) {
    return <div className="body-container">Error loading images.</div>;
  }

  if (!collectionImages || collectionImages.length === 0) {
    return <div className="body-container">No images found in this collection.</div>;
  }

  return (
    <div>
      <div className="body-container">
        <h1>{folder}</h1>
      </div>

      <ImageGrid
        imageData={collectionImages}
        imageCount={imageCount}
        url={folderUrl}
      />
    </div>
  );
}

export default CollectionSpecific;